import React from 'react'
import { formatDateYYYYMMDD, formatMoney } from '../../packages/utils/numberFormatters'
import { useTranslation } from 'react-i18next'
import { IssueTypeText } from './IssueType'
import { Link } from 'react-router-dom'

function IssueLabel({ issue, link, adminLink, blankLink = true }) {
    const { i18n } = useTranslation()
    const locale = i18n.language
    const moreInfo = []

    if (!issue) return null

    if (issue.offeredUnits && issue.unitSubPrice) {
        moreInfo.push(
            formatMoney(issue.offeredUnits * issue.unitSubPrice, {
                locale,
                decimals: 0,
                currencySymbol: issue.currency,
            }),
        )
    }

    if (issue.publicationDate) {
        moreInfo.push(formatDateYYYYMMDD(issue.publicationDate))
    } else if (issue.sources?.length > 0 && issue.sources.some((source) => source.sourceType === 'Publication')) {
        const publicationDate = issue.sources.find((source) => source.sourceType === 'Publication').publishedDate
        if (publicationDate) moreInfo.push(formatDateYYYYMMDD(publicationDate))
    }

    if (issue.type === 'Non-cash issue' && issue.noncashConsideration) {
        moreInfo.push(issue.noncashConsideration)
    }

    let moreInfoPart = null
    if (moreInfo.length > 0) {
        moreInfoPart = `(${moreInfo.join(', ')})`
    }

    if (link || adminLink) {
        const href = link ? `/issues/${issue.id}` : `/admin/issues/${issue.id}`
        return (
            <span>
                <Link to={href} target={blankLink ? '_blank' : '_self'}>
                    <IssueTypeText issueType={issue.type} />
                </Link>{' '}
                {moreInfoPart}
            </span>
        )
    } else {
        return (
            <>
                <IssueTypeText issueType={issue.type} /> {moreInfoPart}
            </>
        )
    }
}

export { IssueLabel }
